export default __webpack_public_path__ + "static/media/customers-icon.7b4c5ba4.svg";